import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard  {
  constructor(private authService: AuthService, public router: Router) {
  }
  canActivate(): boolean {
    if (!this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
      // sessionStorage.setItem('isLogin', JSON.stringify(false));
      localStorage.setItem('isLogin', JSON.stringify(false));

      return false;
    }
    return true;
  }
}
